import _ from 'lodash';

const userScheduleConfigs = [
	{
		userAssignmentTypeId: 'user-abc-a-shift',
		display: 'CA : A Schedule',
		isTypeA: true,
		state: 'ca',
	},
	{
		userAssignmentTypeId: 'user-abc-b-shift',
		display: 'CA : B Schedule',
		isTypeB: true,
		state: 'ca',
	},
	{
		userAssignmentTypeId: 'user-abc-c-shift',
		display: 'CA : C Schedule',
		isTypeC: true,
		state: 'ca',
	},
	{
		userAssignmentTypeId: 'or-user-abc-a-shift',
		display: 'OR : A Schedule',
		isTypeA: true,
		state: 'or',
	},
	{
		userAssignmentTypeId: 'or-user-abc-b-shift',
		display: 'OR : B Schedule',
		isTypeB: true,
		state: 'or',
	},
	{
		userAssignmentTypeId: 'or-user-abc-c-shift',
		display: 'OR : C Schedule',
		isTypeC: true,
		state: 'or',
	},
	{
		userAssignmentTypeId: 'wa-user-abc-a-shift',
		display: 'WA : A Schedule',
		isTypeA: true,
		state: 'wa',
	},
	{
		userAssignmentTypeId: 'wa-user-abc-b-shift',
		display: 'WA : B Schedule',
		isTypeB: true,
		state: 'wa',
	},
	{
		userAssignmentTypeId: 'wa-user-abc-c-shift',
		display: 'WA : C Schedule',
		isTypeC: true,
		state: 'wa',
	},
	//
	//- Generic
	{
		userAssignmentTypeId: '5-2-mon-fri',
		display: '5/2 : Monday - Friday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-tues-sat',
		display: '5/2 : Tuesday - Saturday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-wed-sun',
		display: '5/2 : Wednesday - Sunday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-thur-mon',
		display: '5/2 : Thursday - Monday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-fri-tues',
		display: '5/2 : Friday - Tuesday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-sat-wed',
		display: '5/2 : Saturday - Wednesday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '5-2-sun-thur',
		display: '5/2 : Sunday - Thursday',
		isGeneric: true,
		state: 'generic',
	},
	//
	//- 6/1
	{
		userAssignmentTypeId: '6-1-mon-sat',
		display: '6/1 : Monday - Saturday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-tues-sun',
		display: '6/1 : Tuesday - Sunday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-wed-mon',
		display: '6/1 : Wednesday - Monday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-thur-tues',
		display: '6/1 : Thursday - Tuesday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-fri-wed',
		display: '6/1 : Friday - Wednesday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-sat-thur',
		display: '6/1 : Saturday - Thursday',
		isGeneric: true,
		state: 'generic',
	},
	{
		userAssignmentTypeId: '6-1-sun-fri',
		display: '6/1 : Sunday - Friday',
		isGeneric: true,
		state: 'generic',
	},
];

const userScheduleConfig = {};
userScheduleConfigs.forEach((config, i) => {
	config.sortId = i;
	userScheduleConfig[config.userAssignmentTypeId] = config;
});

export function getUserAssignmentType({ userAssignmentTypeId }) {
	return userScheduleConfig[userAssignmentTypeId] || {};
}

export function getUserAssignmentTypeDisplay({ userAssignmentTypeId }) {
	return _.get(getUserAssignmentType({ userAssignmentTypeId }), 'display', userAssignmentTypeId);
}

export const getUserAssignmentTypeList = userScheduleConfigs;

export function getUserAssignmentOptions({ state }) {
	const optionsForState = [];

	userScheduleConfigs.forEach((config) => {
		if (!config.isGeneric && config.state !== state) {
			return;
		}
		optionsForState.push({
			value: config.userAssignmentTypeId,
			display: config.display,
		});
	});
	return optionsForState;
}

export function getEquipmentAssignmentType({ equipmentAssignmentTypeId }) {
	return userScheduleConfig[equipmentAssignmentTypeId] || {};
}

export function getEquipmentAssignmentTypeDisplay({ equipmentAssignmentTypeId }) {
	return _.get(
		getEquipmentAssignmentType({ equipmentAssignmentTypeId }),
		'display',
		equipmentAssignmentTypeId
	);
}
